import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const InsertLinkModal = ({ show, initialText, onClose, onInsert }) => {
  const [url, setUrl] = useState("");
  const [text, setText] = useState("");

  useEffect(() => {
    if (show) {
      setUrl("");
      setText(initialText || "");
    }
  }, [show, initialText]);

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
      onClose();
      return;
    }
    onInsert({ url: trimmedUrl, text: text.trim() });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="contract-modal-dialog contract-link-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Insert link</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="contract-link-field">
            <label className="contract-modal-label">URL</label>
            <input
              className="contract-modal-input"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              autoFocus
              placeholder="https://"
            />
          </div>
          <div className="contract-link-field">
            <label className="contract-modal-label">Display text</label>
            <input
              className="contract-modal-input"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Optional — defaults to URL"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Insert
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default InsertLinkModal;
